<template>
<CRow>
    <CCol col="12" sm="12" md="10" lg="7" xl="6" class="mx-auto px-0">
        <CCard class="shadow-sm p-0 mt-0 border-radius-0">
            <CCardBody>
                <CRow>
                    <CCol col="12">
                        <CButton color="primary" class="mb-3" @click="showModal = !showModal">بنر جدید</CButton>
                        <CModal :show.sync="showModal" class="lg">
                            <template #header-wrapper>
                                <span></span>
                            </template>
                            <Form ref="createForm" :submit="submit" :promotion="promotion" hideStore />
                            <template #footer-wrapper>
                                <span></span>
                            </template>
                        </CModal>
                        <PromotionsTable ref="promotionsTable" />
                    </CCol>
                </CRow>
            </CCardBody>
        </CCard>
    </CCol>
</CRow>
</template>

<script>
import {
    PromotionsTable,
} from './../partials'
import { Form } from '@/views/promotions/partials'
import { PromotionType } from '@/constants'
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'SetBanner',

    components: {
        Form,
        PromotionsTable,
    },

    data() {
        return {
            showModal: false,
            promotion: {
                type: PromotionType.BANNER,
                title: '',
                href: '',
                alt_tag: '',
                images: [],
                store_id: null
            },
        }
    },

    computed: {
        ...mapGetters({
            store: 'store/firstStore'
        })
    },

    methods: {
        ...mapActions({
            create: 'promotion/create',
            fetchPromotions: 'promotion/fetch',
            setMsg: 'messageComponent/setMsg',
            resetMsg: 'messageComponent/resetMsg',
            setShowLoading: 'loadingComponent/setShowLoading',
        }),
        submit() {
            const createForm = this.$refs.createForm
            this.setShowLoading()
            this.resetMsg()

            const data = {
                ...this.promotion,
                store_id: this.store.id
            }

            this.create(data).then(result => {
                this.setShowLoading(false)
                this.showModal = false
                this.$refs.createForm.$refs.form.reset()
                this.$refs.createForm.images.sizes.forEach(image => image.uploadPercent = 0)
                this.promotion = {
                    type: PromotionType.BANNER,
                    title: '',
                    href: '',
                    alt_tag: '',
                    images: {},
                    store_id: null
                }
                this.fetchPromotions({
                    no_paginate: true
                })
            }).catch(result => {
                if(result.data) {
                    createForm.$refs.form.setErrors(result.data);
                }
                this.setShowLoading(false)
                this.setMsg({
                    content: this.$t('tags.'+result.tag),
                    type: 'danger'
                })
            })
        },
    }
}
</script>